import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formPopupResubmit_container: {
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupResubmit_inputWrapper: {
			padding: theme.spacing(2, 0),
		},
		formPopupResubmit_instructionLabel: {
			fontSize: theme.typography.h6.fontSize,
			fontWeight: theme.typography.fontWeightBold,
		},
	});
});

export default useStyles;
